import { Auth } from "aws-amplify"
import axios, { InternalAxiosRequestConfig } from "axios"

const api = axios.create()

// Request interceptor injects AWS access token into all API requests
api.interceptors.request.use(async (request: InternalAxiosRequestConfig) => {
    if (request.url?.includes("energynetworks.org")) {
        const session = await Auth.currentSession()
        request.headers.setAuthorization(session.getAccessToken().getJwtToken())
    }
    return request
})

export default api
